import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { UserService } from '@aifs-shared/user/user.service';
import { ApplicantLogComponent } from './applicant/applicant-log/applicant-log.component';

import {
    MenuAction,
    MenuActionType,
    MenuService,
} from '@ui/cf-menu/menu.service';
import {
    CfButtonComponent,
    CFButtonStyle,
    CFButtonType,
} from './ui/cf-button/cf-button.component';
import { LongPressDirective } from '@ui/directive/long-press.directive';
import { UiModalService } from '@ui/ui-modal.service';
import {
    CFLoaderColor,
    CfLoaderComponent,
    CFLoaderSize,
    CFLoaderStyle,
} from '@ui/cf-loader/cf-loader.component';
import {
    CFRowAction,
    CFRowActionEvent,
    CFRowActionOptions,
    CFTableColumn,
    CfTableColumnAlignment,
    CfTableColumnType,
    CfTableComponent,
    CFTableData,
    CFTableRow,
    ICFTableRow,
} from '@ui/cf-table/cf-table.component';
import { ReviewAppStateServiceFactory } from './applicant/application/review/review-app-state-service-factory';
import { CfMapComponent, MapLocation } from "@ui/cf-map/cf-map.component";

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrl: './dashboard.component.scss',
    imports: [
        CommonModule,
        RouterModule,
        CfButtonComponent,
        // CfLoaderComponent,
        // LongPressDirective,
        // CfTableComponent,
        // ApplicantLogComponent,
        CfMapComponent
    ]
})
export class DashboardComponent {
    loginDisplay = false;
    ButtonStyle = CFButtonStyle;
    ButtonType = CFButtonType;

    LoaderSize = CFLoaderSize;
    LoaderStyle = CFLoaderStyle;
    LoaderColor = CFLoaderColor;

    constructor(
        private router: Router,
        private userService: UserService,
        private menuService: MenuService,
        private modalService: UiModalService,
        private reviewAppStateServiceFactory: ReviewAppStateServiceFactory
    ) { }

    ngOnInit(): void {
        this.setLoginDisplay();

        this.menuService.setData(new MenuAction(MenuActionType.ShowAll));

        this.setupTable();
    }

    setLoginDisplay() {
        this.loginDisplay = this.userService.user() !== undefined;
    }

    // MARK: Generic navigate
    jumpLink(event: Event, path: string): void {
        console.log(`Navigating to ${path}`);
        //this.router.navigateByUrl(path);
        this.router.navigate([]).then((result) => {
            window.open(path, '_blank');
        });
    }

    // MARK: Navigate to Application review
    startReview(event: Event, link: ILink): void {
        const path = `/job/${link.jobId}`;
        console.log(`Navigating to ${JSON.stringify(link, null, 2)}`);
        this.reviewAppStateServiceFactory.clearState(link.jobId);
        //this.router.navigateByUrl(path);
        this.router.navigate([]).then((result) => {
            window.open(path, '_blank');
        });
    }

    // MARK: Navigate to Medical review
    startMedicalReview(event: Event, path: string): void {
        //console.log(`Navigating to ${path}`);
        // this.router.navigateByUrl(path);
        this.router.navigate([]).then((result) => {
            window.open(path, '_blank');
        });
    }

    links: ILink[] = [
        {
            jobId: 737,
            userState: 'ParticipantApplied',
            programme: 'CC',
            name: 'Deon - 4898885@testmail.com',
        },
        {
            jobId: 781,
            userState: 'ParticipantApplied',
            programme: 'CC',
            name: 'Avery - 5047425@testmail.com',
        },
        {
            jobId: 757,
            userState: 'ParticipantApplied',
            programme: 'CC',
            name: 'Jamie - 5046474@testmail.com',
        },
        {
            jobId: 711,
            userState: 'ParticipantApplied',
            programme: 'CC',
            name: 'Taylor - 5042973@testmail.com',
        },
        {
            jobId: 765,
            userState: 'ParticipantApplied',
            programme: 'CC',
            name: 'Morgan - 5047012@testmail.com',
        },
        {
            jobId: 670,
            userState: 'ParticipantApplied',
            programme: 'CC',
            name: 'Riley - 5046902@testmail.com',
        },
    ];

    // MARK: Temp
    shortClick(): void {
        console.log(`short click`);
        this.modalService.showModalInformation(
            'Click',
            'This was a short click; show confirmation dialog'
        );
    }

    longClick(): void {
        console.log(`longer click`);
        this.modalService.showModalInformation(
            'Click',
            'This was a long-press click; action immediately'
        );
    }

    // MARK: Table action test
    users?: CFTableData;
    setupTable(): void {
        let columns: CFTableColumn[] = [
            new CFTableColumn(
                'User',
                CfTableColumnAlignment.Left,
                CfTableColumnType.String,
                'col_name'
            ),
            new CFTableColumn(
                'Active tasks',
                CfTableColumnAlignment.Center,
                CfTableColumnType.Number,
                'col_tasks'
            ),
            new CFTableColumn(
                'Auto assign limit',
                CfTableColumnAlignment.Center,
                CfTableColumnType.Number,
                'col_limit'
            ),
        ];
        let tableData: ICFTableRow[] = [];

        tableData.push(new CFTableRow('500', ['Baltazar Bieniek', 15, 12]));
        tableData.push(new CFTableRow('400', ['Dawid Wierzbicki', 5, 10]));
        tableData.push(new CFTableRow(`${200}`, [`Ian Seckington`, 6, 10]));
        tableData.push(new CFTableRow(`${300}`, [`Kerry McSweeney`, 24, 15]));
        tableData.push(new CFTableRow(`${100}`, [`Michael Tolfrey`, 13, 10]));

        let ao = new CFRowActionOptions([
            new CFRowAction('Assign tasks', 2, 3),
            new CFRowAction('Edit', 3, 1),
            new CFRowAction('Remove', 1, 4),
        ]);

        this.users = new CFTableData(
            columns.slice(),
            [...tableData],
            undefined,
            ao
        );
    }

    rowAction(event: CFRowActionEvent): void {
        console.log(`Got Row Action: ${JSON.stringify(event, null, 2)}`);
        if (event.isShowing) {
            this.currentRowAction = event;
            this.currentRowActionCounter = 0;
        } else {
            this.currentRowAction = undefined;
            this.currentRowActionCounter = 0;
        }
    }

    rowActionSaveChange(): void {
        if (this.currentRowAction) {
            const app = this.users!.rows.find(
                (u) => u.pk == this.currentRowAction!.rowPrimaryKey
            );
            if (this.currentRowAction.action.text === 'Remove') {
                console.log(`Remove ${app?.cols[0]}`);
            } else {
                console.log(`Save ${app?.cols[0]}`);
            }
        }
    }

    rowActionPlus(type: string, amount: number): void {
        if (this.currentRowAction) {
            const app = this.users!.rows.find(
                (u) => u.pk == this.currentRowAction!.rowPrimaryKey
            );
            console.log(`Plus ${amount} to ${app?.cols[0]} ${type}`);
            this.currentRowActionCounter += amount;
        }
    }

    hasLocation = false;
    location?: string;
    selectedLocation?: MapLocation;
    canAdd = false;
    mapLoaded(loaded: boolean) {
        console.log(`Loaded map code, locations available: ${this.loadedLocations.length}`);
        this.locations = this.loadedLocations.slice();
    }

    mapLocationChanged(location: MapLocation) {
        this.hasLocation = location !== undefined;
        this.location = `<h2>${location.title}</h2><p>${location.address?.replace(/[,][ ]*/gm, '<br>')}<br>{ ${location.lat}, ${location.lng} }</p>`;
        this.selectedLocation = location;
        const already = this.locations.find(l => l.id === location.id);
        this.canAdd = !already;
    }

    addSelectedLocation() {
        const location = this.selectedLocation;
        if (location) {
            const already = this.locations.find(l => l.id === location.id);
            if (!already) {
                console.log(`Adding new location`);
                const loc = this.locations.slice();
                loc.push(location);

                this.locations = loc.slice();
            }
        }
    }

    locations: MapLocation[] = [];
    loadedLocations: MapLocation[] = [
        new MapLocation("ChIJT7k0XVwFdkgRczK6DjvoCQg", 51.49771570000001, -0.17987509999999998, "Camp America", "37 Queen's Gate, South Kensington, London SW7 5HR, UK"),
        new MapLocation("ChIJuW4AjG8FdkgRDb_vqbTS508", 51.484750299999995, -0.1755033, "Bluebird Chelsea", "350 King's Rd, London SW3 5UU, UK"),
    ];

    currentRowAction?: CFRowActionEvent;
    currentRowActionCounter = 0;
}

export interface ILink {
    jobId: number;
    userState: string;
    programme: string;
    name?: string;
}
